export const statusOptionDi = [
  // { value: 'APPROVED', label: 'APPROVED' },
  // { value: 'BEFORE_ID_PROOF', label: 'BEFORE ID PROOF' },
  // { value: 'DONE_ID_PROOF', label: 'DONE ID PROOF' },
  // { value: 'ADM_RENEWED', label: 'ADM RENEWED' },
  // {
  //   value: 'CERTIFICATE_GENERATION_IN_PROCESS',
  //   label: 'CERTIFICATE GENERATION IN PROCESS',
  // },
  // {
  //   value: 'ADMIN_ROLES_PROVISIONED',
  //   label: 'ADMIN ROLES PROVISIONED',
  // },
  {
    value: 'ADMIN_ROLES_REVOKED',
    label: 'ADMIN ROLES REVOKED',
  },
  // {
  //   value: 'CERTIFICATE_MIGRATED',
  //   label: 'CERTIFICATE MIGRATED',
  // },
  // {
  //   value: 'CERTIFICATE_READY_FOR_DOWNLOAD',
  //   label: 'CERTIFICATE READY FOR DOWNLOAD',
  // },
  // {
  //   value: 'CERTIFICATE_DOWNLOADED',
  //   label: 'CERTIFICATE DOWNLOADED',
  // },
  {
    value: 'CERTIFICATE_REVOKED',
    label: 'CERTIFICATE REVOKED',
  },
  {
    value: 'CERTIFICATE_REVOCATION_IN_PROCESS',
    label: 'CERTIFICATE REVOCATION IN PROCESS',
  },
  { value: 'FAILURE', label: 'FAILURE' },
  // { value: 'SUCCESS', label: 'SUCCESS' },
  // { value: 'IN_PROCESS', label: 'IN PROCESS' },
  // { value: 'NEW', label: 'NEW' },
  // { value: 'OPEN', label: 'OPEN' },
  // { value: 'REJECTED', label: 'REJECTED' },
  { value: 'CANCELLED', label: 'CANCELLED' },
  // { value: 'RENEWED', label: 'RENEWED' },
  { value: 'REVOKED', label: 'REVOKED' },
  { value: 'SUBMITTED', label: 'SUBMITTED' },
  { value: '%25', label: 'ALL' },
];
export const statusOptionRa = [
  { value: 'APPROVED', label: 'APPROVED' },
  { value: 'ADM_RENEWED', label: 'ADM RENEWED' },
  { value: 'CERTIFICATE_GENERATION_IN_PROCESS', label: 'CERTIFICATE GENERATION IN PROCESS' },
  { value: 'ADMIN_ROLES_PROVISIONED', label: 'ADMIN ROLES PROVISIONED' },
  { value: 'ADMIN_ROLES_REVOKED', label: 'ADMIN ROLES REVOKED' },
  { value: 'CERTIFICATE_MIGRATED', label: 'CERTIFICATE MIGRATED' },
  { value: 'CERTIFICATE_READY_FOR_DOWNLOAD', label: 'CERTIFICATE READY FOR DOWNLOAD' },
  { value: 'CERTIFICATE_DOWNLOADED', label: 'CERTIFICATE DOWNLOADED' },
  { value: 'CERTIFICATE_REVOKED', label: 'CERTIFICATE REVOKED' },
  { value: 'CERTIFICATE_REVOCATION_IN_PROCESS', label: 'CERTIFICATE REVOCATION IN PROCESS' },
  { value: 'FAILURE', label: 'FAILURE' },
  { value: 'SUCCESS', label: 'SUCCESS' },
  { value: 'IN_PROCESS', label: 'IN PROCESS' },
  { value: 'NEW', label: 'NEW' },
  { value: 'REJECTED', label: 'REJECTED' },
  { value: 'CANCELLED', label: 'CANCELLED' },
  { value: 'RENEWED', label: 'RENEWED' },
  { value: 'REVOKED', label: 'REVOKED' },
  { value: 'SUBMITTED', label: 'SUBMITTED' },
  { value: '%25', label: 'ALL' },
  // { value: 'APPROVED', label: 'APPROVED' },
  // { value: 'BEFORE_ID_PROOF', label: 'BEFORE ID PROOF' },
  // { value: 'DONE_ID_PROOF', label: 'DONE ID PROOF' },
  // { value: 'ADM_RENEWED', label: 'ADM RENEWED' },
  // {
  //   value: 'CERTIFICATE_GENERATION_IN_PROCESS',
  //   label: 'CERTIFICATE GENERATION IN PROCESS',
  // },
  // {
  //   value: 'ADMIN_ROLES_PROVISIONED',
  //   label: 'ADMIN ROLES PROVISIONED',
  // },
  // {
  //   value: 'ADMIN_ROLES_REVOKED',
  //   label: 'ADMIN ROLES REVOKED',
  // },
  // {
  //   value: 'CERTIFICATE_MIGRATED',
  //   label: 'CERTIFICATE MIGRATED',
  // },
  // {
  //   value: 'CERTIFICATE_READY_FOR_DOWNLOAD',
  //   label: 'CERTIFICATE READY FOR DOWNLOAD',
  // },
  // {
  //   value: 'CERTIFICATE_DOWNLOADED',
  //   label: 'CERTIFICATE DOWNLOADED',
  // },
  // {
  //   value: 'CERTIFICATE_REVOKED',
  //   label: 'CERTIFICATE REVOKED',
  // },
  // {
  //   value: 'CERTIFICATE_REVOCATION_IN_PROCESS',
  //   label: 'CERTIFICATE REVOCATION IN PROCESS',
  // },
  // { value: 'FAILURE', label: 'FAILURE' },
  // { value: 'SUCCESS', label: 'SUCCESS' },
  // { value: 'IN_PROCESS', label: 'IN PROCESS' },
  // { value: 'NEW', label: 'NEW' },
  // { value: 'OPEN', label: 'OPEN' },
  // { value: 'REJECTED', label: 'REJECTED' },
  // { value: 'CANCELLED', label: 'CANCELLED' },
  // { value: 'RENEWED', label: 'RENEWED' },
  // { value: 'REVOKED', label: 'REVOKED' },
  // { value: 'SUBMITTED', label: 'SUBMITTED' },
  // { value: '%25', label: 'ALL' },
];

export const getLabelByValueDi = (value: string | undefined) => {
  const option = statusOptionDi.find(option => option.value === value);
  return option ? option.label : null; // Return label if found, otherwise null
};

export const getLabelByValueRa = (value: string | undefined) => {
  const option = statusOptionRa.find(option => option.value === value);
  return option ? option.label : null; // Return label if found, otherwise null
};
